<template>
  <div>
    <md-card
      class="md-card-unspaced public-interactions-card public-interactions-timeline"
      :class="{ 'public-interactions-timeline-active': !isCompactCollapsed }"
    >
      <div
        class="md-layout"
        @click="item.steps && (isCompactCollapsed = !isCompactCollapsed)"
      >
        <div
          class="md-layout md-layout-item md-large-size-90 md-small-size-90 md-xsmall-size-70 md-gutter-sm md-alignment-center-left public-interactions-timeline-item"
        >
          <span
            class="public-interactions-status"
            :class="'rfider-status-' + item.status + '-color'"
          ></span>
          <img
            v-if="item.batchId && item.batchEnabled"
            class="public-interactions-batch-record"
            src="/img/icons/Batch-Record-Indicator.png"
          />

          <div class="md-layout md-layout-item md-size-100">
            <div class="md-layout-item title">
              {{ getTranslatedText(item.title) }}
            </div>
          </div>

          <div
            class="md-layout md-layout-item md-size-100"
            style="margin-top: 5px"
          >
            <div class="md-layout-item md-size-100 public-interactions-bold">
              {{
                displayTimeZone(
                  item.replacedDate || item.createdAt,
                  'DD MMMM YYYY',
                )
              }}
            </div>
            <div
              v-if="!item.isAdmin && enrichedData"
              class="md-layout-item md-size-100"
            >
              {{ enrichedData.location }}
            </div>
          </div>
        </div>
        <div
          class="md-layout-item md-large-size-10 md-small-size-10 md-xsmall-size-30"
        >
          <div
            class="md-layout-item--no-grow"
            v-if="isEventGalleryInteraction && firstEventGalleryImage"
          >
            <md-button
              class="md-simple attaches"
              @click="openModal = !openModal"
            >
              <img :src="firstEventGalleryImage" />
            </md-button>
          </div>
        </div>
        <div class="md-layout-item md-size-100" v-if="!isCompactCollapsed">
          <div
            class="public-interactions-steps"
            v-for="(step, index) in item.steps"
            :key="index"
          >
            <div
              class="md-layout md-gutter-sm md-alignment-top-left public-interactions-timeline-item"
            >
              <div
                class="md-layout-item public-interactions-step-link"
                v-if="step.stepLink"
              >
                <a href @click.prevent="searchStep(step.stepLink)">
                  <div class="public-interactions-bold">
                    {{ getTranslatedText(step.name) }}
                  </div>
                  <br />
                  <div
                    v-if="step.description"
                    class="public-interactions-step-title"
                  >
                    {{ getStatus(step.description) || step.description }}
                  </div>
                </a>
                <a
                  href
                  @click.prevent="searchStep(step.stepLink)"
                  class="public-interactions-step-link-icon"
                >
                  <md-icon class="md-size-1-5px">arrow_right</md-icon>
                </a>
              </div>
              <div class="md-layout-item" v-else>
                <div class="public-interactions-bold">
                  {{ getTranslatedText(step.name) }}
                </div>
                <br />
                <!-- eslint-disable -->
                <div
                  v-if="step.description"
                  class="public-interactions-step-title public-interaction-description-content"
                  v-html="getStatus(step.description) || step.description"
                >
                </div>
                <!--eslint-enable-->
              </div>
            </div>
          </div>
          <div v-if="item.actions">
            <div
              class="public-interactions-steps"
              v-for="(action, index) in item.actions"
              :key="index"
            >
              <div
                class="md-layout md-gutter-sm md-alignment-top-left public-interactions-timeline-item"
              >
                <div class="md-layout-item">
                  <span class="public-interactions-bold">{{
                    $t('interaction_action_' + action.type).slice(0, -1)
                  }}</span>
                  <br />
                  <span>
                    {{ getStatus(action.message) || action.message }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- <div v-if="item.status >= 0 && item.statusMessage">
            <div class="public-interactions-steps">
              <div
                class="md-layout md-gutter-sm md-alignment-top-left public-interactions-timeline-item"
              >
                <div class="md-layout-item">
                  <span class="public-interactions-bold">{{
                    $t('interaction_action_0').slice(0, -1) + ' '
                  }}</span>
                  <br />
                  <span>{{ item.statusMessage }}</span>
                </div>
              </div>
            </div>
          </div> -->
        </div>
        <div class="md-layout-item md-size-100 text-align--center">
          <md-button
            class="md-simple"
            style="width: 24px"
            :disabled="!item.steps"
          >
            <img
              v-if="item.steps && isCompactCollapsed"
              src="/img/icons/timeline_down_arrow.png"
            />
            <img
              v-else-if="item.steps"
              src="/img/icons/timeline_up_arrow.png"
            />
          </md-button>
        </div>
      </div>
    </md-card>

    <public-interactions-event-gallery
      :open-modal="openModal"
      :item="item"
      @toggle-dialog="toggleDialog"
      :task-img-promise="taskImgPromise"
    ></public-interactions-event-gallery>
  </div>
</template>

<script>
import timeZone from '@/mixins/timeZone';
import PublicInteractionsEventGallery from './../public/publicInteractionsEventGallery.vue';

export default {
  mixins: [timeZone],
  components: {
    PublicInteractionsEventGallery,
  },
  props: {
    item: Object,
    taskImgPromise: { type: Function },
  },
  data() {
    return {
      enrichedData: null,
      isCompactCollapsed: true,
      openModal: false,
      // fakeData: [
      //   {
      //     src: 'local-environment/portal/org_4/Beverage-copy-1dkse76vd3.png',
      //   },
      //   {
      //     src:
      //       'https://storage.googleapis.com/rfider-dev-file-uploads/local-environment/fixtures/thing/avatar-organization-default.png',
      //   },
      // ],
    };
  },
  computed: {
    blockchainIntegrations() {
      const arr = [];
      const tags = this.item.tags || [];
      tags.forEach((t) => {
        if (t === 'integration-ibmFoodTrust') {
          arr.push('IBM Food Trust');
        }
      });
      return arr.length ? arr : null;
    },
    isEventGalleryInteraction() {
      return !!(
        this.item.showEventGallery &&
        Array.isArray(this.item.tags) &&
        this.item.tags.includes('eventGallery')
      );
    },
    firstEventGalleryImage() {
      let firstEventGalleryImage = null;

      // Checking interaction images
      const interactionImages = this.extractAttachmentsImages(this.item);
      if (interactionImages.length) {
        firstEventGalleryImage = this.mixinGetFilePath(
          interactionImages[0].src,
          'S',
        );
      } else {
        // Checking interaction steps's images
        if (this.item.steps) {
          for (const step of this.item.steps) {
            const stepImages = this.extractAttachmentsImages(step);
            if (stepImages.length) {
              firstEventGalleryImage = this.mixinGetFilePath(
                stepImages[0].src,
                'S',
              );
              break;
            }
          }
        }
      }

      return firstEventGalleryImage;
    },
  },
  watch: {
    item: {
      immediate: true,
      handler(newItem) {
        if (newItem.metadata) {
          const { temp, rh, aqi } = newItem.metadata.location.weather || {};
          const locationDetails = newItem.metadata.replacedLocation
            ? newItem.metadata.replacedLocation.details
            : newItem.metadata.location.details;

          this.enrichedData = {};
          this.enrichedData.location = this.extractLocationData(
            locationDetails || {},
          );

          if (temp && rh && aqi) {
            this.enrichedData.weather =
              `${temp}°C` + ' | ' + `RH ${rh}%` + ' | ' + `AQI ${aqi}`;
          } else {
            this.enrichedData.weather = 'Weather Unavailable';
          }
        } else {
          this.enrichedData = null;
        }
      },
    },
  },
  methods: {
    toggleDialog() {
      this.openModal = !this.openModal;
    },
    extractAttachmentsImages(object) {
      let images = [];
      if (object.metadata && Array.isArray(object.metadata.attachments)) {
        object.metadata.attachments.forEach((attachment) => {
          if (this.mixinGetImageRegex().test(attachment.file)) {
            images.push({
              src: attachment.file,
            });
          }
        });
      }
      // images = images.concat(this.fakeData);
      return images;
    },
    searchStep(stepInfo) {
      window.open(stepInfo, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/public/_public-interactions.scss';
</style>
